module.exports = __webpack_public_path__ + "static/media/template5.495d64c5.png";